import { isPlatformBrowser } from "@angular/common";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
declare var localStorage: any;

@Injectable()
export class LocalStorageService {
    constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

    public setItem(key: string, value: string) {
        if (isPlatformBrowser(this.platformId))
            localStorage.setItem(key, value);
    }

    public getItem(key: string): any {
        if (isPlatformBrowser(this.platformId))
            return localStorage.getItem(key);
    }

    public removeItem(key: string) {
        if (isPlatformBrowser(this.platformId))
            localStorage.removeItem(key)
    }

    public clearStorage() {
        if (isPlatformBrowser(this.platformId))
            localStorage.clear();
    }
}